export default __webpack_public_path__ + "static/media/CC-exp.6cd7337a.png";